export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Is this a physical product?',
    answer:
      'No. PRENATAL FITNESS COACH PRO™ is a 100% digital professional educational system.',
  },
  {
    question: 'Is this designed for fitness professionals?',
    answer:
      'Yes. It is designed for prenatal fitness coaches, personal trainers and qualified exercise professionals working with pregnant clients.',
  },
  {
    question: 'Is this another basic prenatal fitness course?',
    answer:
      'No. The focus is practical implementation: assessment tools, exercise resources, modifications, sessions, programs, templates and client management systems.',
  },
  {
    question: 'Are the sessions already created?',
    answer:
      'Yes. The system includes complete session structures plus 30 additional ready-to-coach sessions in the bonus library.',
  },
  {
    question: 'Can I adapt the material to different clients?',
    answer:
      'Yes. Individualization is central to the system. The resources include regressions, progressions, substitutions and adaptation frameworks.',
  },
  {
    question: 'Does this replace medical guidance?',
    answer:
      'No. PRENATAL FITNESS COACH PRO™ is an educational fitness coaching resource and does not replace medical advice, diagnosis or individualized healthcare guidance.',
  },
  {
    question: 'Can this save me planning time?',
    answer:
      'That’s exactly what the system is designed to do: give you structured professional resources so you don’t need to create everything from zero.',
  },
  {
    question: 'How will I receive it?',
    answer: 'You’ll receive digital access immediately after purchase.',
  },
  {
    question: 'Can I use the templates and resources with my own clients?',
    answer:
      'Yes. The planners, profiles, trackers, session structures and coaching tools are made to be used inside your own professional practice with your prenatal clients.',
  },
  {
    question: 'How long do I keep access?',
    answer:
      'The system is yours to keep. Download the modules, bonuses and templates once and use them with every client from that point forward.',
  },
]
